<template>
    <div>
        <div class="btn-box">
            <van-button class="btn" type="primary" @click="start" :disabled="!init_status">开始游戏</van-button>
        </div>
        <div class="btn-box">
            <van-button class="btn" plain type="info" @click="share" :disabled="!init_status">邀请朋友一起玩</van-button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "RainIndex",
        data(){
            return {
                openid:'',//this.$store.getters.getLoginUser.openid, //当前登录用户的open_id
                client_id:'1002',//this.$store.getters.getLoginUser.id,  //当前登录用户的id
                game_id:'1',          //游戏编号
                init_status:false,  //初始化状态
                ticket_qty:0,       //当前用户的可用入场券数量
            }
        },
        methods:{
            ...mapActions([
                'CreateUserPrizePool',
                'CheckGameTicket'
            ]),
            share(){
                console.log('创建海报用于分享');
            },
            start(){
                if(this.ticket_qty>0){
                    //消耗一次入场券
                    let p={'uid':this.client_id,'gid':this.game_id};
                    this.CheckGameTicket(p).then(res=>{
                        if(res.status>0){
                            //核销失败
                            this.$Dialog.alert({
                                message: '您的草莓雨入场券已用完，去邀请朋友一起玩以获得更多入场券！',
                                theme: 'round-button',
                            });
                        }else{
                            //核销成功
                            this.ticket_qty = res.responseObject;   //更新剩余入场券数量
                            let uid=this.client_id;
                            let gid=this.game_id;
                            let ticket_qty=this.ticket_qty;
                            this.$router.push({name:'RainGame',params:{uid,gid,ticket_qty}});
                        }
                    });
                }else{
                    this.$Dialog.alert({
                        message: '您的草莓雨入场券已用完，去邀请朋友一起玩以获得更多入场券！',
                        theme: 'round-button',
                    });
                }
            },
            init(){
                let p={'uid':this.client_id,'gid':this.game_id};
                this.CreateUserPrizePool(p).then(res=>{
                    console.log(res);
                    if(res.status===0){
                        //初始化成功
                        this.ticket_qty=res.responseObject;
                        this.init_status=true;
                    }
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>

<style scoped lang="scss">
    .btn-box{
        text-align: center;
        padding-top: 30px;
        .btn{
            width: 80%;
            height: 50px;
        }
    }

</style>
